"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCw20Token = exports.calculateMaxFee = exports.parseChainId = exports.BlockchainMap = exports.getIbcChainFromBlockchain = exports.ChainIdBlockchainMap = exports.totalAssetObj = exports.EmbedChainInfos = exports.makeIBCMinimalDenom = void 0;
const constant_1 = require("../constant");
const provider_1 = require("../provider");
const crypto_1 = require("@keplr-wallet/crypto");
const blockchain_1 = require("./blockchain");
// Create IBC minimal denom
function makeIBCMinimalDenom(sourceChannelId, coinMinimalDenom) {
    const sourceChannelIdProcess = sourceChannelId.indexOf("transfer/") === 0 ? sourceChannelId.split("/").splice(1).join("/") : sourceChannelId;
    return ("ibc/" +
        Buffer.from(crypto_1.Hash.sha256(Buffer.from(`transfer/${sourceChannelIdProcess}/${coinMinimalDenom}`)))
            .toString("hex")
            .toUpperCase());
}
exports.makeIBCMinimalDenom = makeIBCMinimalDenom;
exports.EmbedChainInfos = Object.values(constant_1.EmbedChainInfosInit).reduce((prev, chainInfo) => {
    var _a, _b;
    if (constant_1.swthIbcWhitelist.includes(chainInfo.chainId)) {
        const chainChannels = (_a = constant_1.swthChannels[chainInfo.chainId]) === null || _a === void 0 ? void 0 : _a.ibc;
        chainInfo.currencies.push(Object.assign(Object.assign({}, provider_1.KeplrAccount.SWTH_CURRENCY), { coinMinimalDenom: makeIBCMinimalDenom((_b = chainChannels === null || chainChannels === void 0 ? void 0 : chainChannels.dstChannel) !== null && _b !== void 0 ? _b : "channel-0", provider_1.KeplrAccount.SWTH_CURRENCY.coinMinimalDenom) }));
    }
    prev[chainInfo.chainId] = chainInfo;
    return prev;
}, {});
exports.totalAssetObj = Object.values(exports.EmbedChainInfos).reduce((prev, chainInfo) => {
    if (!constant_1.ibcWhitelist.includes(chainInfo.chainId))
        return prev;
    const newAssetObj = prev;
    const assetsObj = {};
    const channelsObj = constant_1.swthChannels[chainInfo.chainId];
    chainInfo.currencies.forEach((currency) => {
        var _a;
        const channelSet = currency.hasOwnProperty('type') && channelsObj.cw20
            ? channelsObj.cw20
            : channelsObj.ibc;
        let ibcAddr = currency.coinDenom.toLowerCase() === "swth"
            ? currency.coinMinimalDenom
            : makeIBCMinimalDenom((_a = channelSet === null || channelSet === void 0 ? void 0 : channelSet.sourceChannel) !== null && _a !== void 0 ? _a : "channel-0", currency.coinMinimalDenom);
        // TODO: Remove when implementing dynamic ibc chain info
        if (currency.coinMinimalDenom === "ibc/D189335C6E4A68B513C10AB227BF1C1D38C746766278BA3EEB4FB14124F1D858") {
            ibcAddr = "ibc/7FBDBEEEBA9C50C4BCDF7BF438EAB99E64360833D240B32655C96E319559E911";
        }
        assetsObj[ibcAddr] = currency;
    });
    newAssetObj[chainInfo.chainId] = assetsObj;
    return newAssetObj;
}, {});
exports.ChainIdBlockchainMap = {
    [constant_1.ChainIds.Osmosis]: blockchain_1.Blockchain.Osmosis,
    [constant_1.ChainIds.Terra]: blockchain_1.Blockchain.Terra,
    [constant_1.ChainIds.CosmosHub]: blockchain_1.Blockchain.CosmosHub,
    [constant_1.ChainIds.Juno]: blockchain_1.Blockchain.Juno,
    [constant_1.ChainIds.Evmos]: blockchain_1.Blockchain.Evmos,
    [constant_1.ChainIds.Axelar]: blockchain_1.Blockchain.Axelar,
    [constant_1.ChainIds.Stride]: blockchain_1.Blockchain.Stride,
    [constant_1.ChainIds.Kujira]: blockchain_1.Blockchain.Kujira,
    [constant_1.ChainIds.Terra2]: blockchain_1.Blockchain.Terra2,
    [constant_1.ChainIds.Quicksilver]: blockchain_1.Blockchain.Quicksilver,
    [constant_1.ChainIds.Comdex]: blockchain_1.Blockchain.Comdex,
    [constant_1.ChainIds.StafiHub]: blockchain_1.Blockchain.StafiHub,
    [constant_1.ChainIds.Persistence]: blockchain_1.Blockchain.Persistence,
    [constant_1.ChainIds.Stargaze]: blockchain_1.Blockchain.Stargaze,
    [constant_1.ChainIds.Canto]: blockchain_1.Blockchain.Canto,
    [constant_1.ChainIds.OmniFlixHub]: blockchain_1.Blockchain.OmniFlixHub,
    [constant_1.ChainIds.Agoric]: blockchain_1.Blockchain.Agoric,
    [constant_1.ChainIds.Sommelier]: blockchain_1.Blockchain.Sommelier,
};
const getIbcChainFromBlockchain = (blockchain) => {
    let ibcChain = undefined;
    Object.entries(exports.ChainIdBlockchainMap).forEach(([key, value]) => {
        if (blockchain && blockchain.includes(value)) {
            ibcChain = key;
        }
    });
    return ibcChain;
};
exports.getIbcChainFromBlockchain = getIbcChainFromBlockchain;
exports.BlockchainMap = Object.values(exports.EmbedChainInfos).reduce((prev, chainInfo) => {
    if (!constant_1.ibcWhitelist.includes(chainInfo.chainId)) {
        return prev;
    }
    const newPrev = prev;
    const channelsObj = constant_1.swthChannels[chainInfo.chainId];
    chainInfo.currencies.forEach((currency) => {
        var _a;
        // TODO: Remove when implementing dynamic ibc chain info
        if (currency.coinMinimalDenom === "ibc/D189335C6E4A68B513C10AB227BF1C1D38C746766278BA3EEB4FB14124F1D858") {
            newPrev["ibc/7FBDBEEEBA9C50C4BCDF7BF438EAB99E64360833D240B32655C96E319559E911"] = exports.ChainIdBlockchainMap[chainInfo.chainId];
            return;
        }
        if (currency.coinDenom.toLowerCase() === "swth") {
            newPrev[currency.coinMinimalDenom] = exports.ChainIdBlockchainMap[chainInfo.chainId];
        }
        else {
            const channelSet = currency.hasOwnProperty('type') && channelsObj.cw20
                ? channelsObj.cw20
                : channelsObj.ibc;
            const ibcAddr = makeIBCMinimalDenom((_a = channelSet === null || channelSet === void 0 ? void 0 : channelSet.sourceChannel) !== null && _a !== void 0 ? _a : "channel-0", currency.coinMinimalDenom);
            newPrev[ibcAddr] = exports.ChainIdBlockchainMap[chainInfo.chainId];
        }
    });
    return newPrev;
}, {});
const parseChainId = (chainId) => {
    var _a, _b;
    const chainArr = chainId.match(constant_1.ibcNetworkRegex);
    return {
        identifier: (_a = chainArr === null || chainArr === void 0 ? void 0 : chainArr[1]) !== null && _a !== void 0 ? _a : "",
        version: parseInt((_b = chainArr === null || chainArr === void 0 ? void 0 : chainArr[2]) !== null && _b !== void 0 ? _b : "0"),
    };
};
exports.parseChainId = parseChainId;
const calculateMaxFee = (gasStep = constant_1.DefaultGasPriceStep, gas = 0) => {
    return gasStep.high * gas;
};
exports.calculateMaxFee = calculateMaxFee;
const isCw20Token = (currency) => {
    if (!currency.hasOwnProperty("type"))
        return false;
    const depositCurrency = currency;
    return depositCurrency.type === "cw20";
};
exports.isCw20Token = isCw20Token;
